import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  
  return (
    <header className="bg-white py-4 px-8">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src="/Practice Dashboard favicon.png" 
            alt="Practice Dashboard Logo" 
            className="w-10 h-10 mr-3 rounded-full"
          />
          <h1 className="text-xl font-semibold text-gray-900">Practice Dashboard</h1>
        </Link>
        
        <nav className="flex items-center space-x-8">
          <Link 
            to="/pricing" 
            className={`font-medium transition-colors ${
              location.pathname === '/pricing' 
                ? 'text-orange-500' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Pricing
          </Link>
          <Link 
            to="/contact" 
            className={`font-medium transition-colors ${
              location.pathname === '/contact' 
                ? 'text-orange-500' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Contact Us
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;